import PropTypes from 'prop-types';
import React from 'react';
import {useIntl} from 'react-intl';

FileName.propTypes = {
    feed: PropTypes.shape({
        name: PropTypes.string,
        dataType: PropTypes.string.isRequired,
        transportType: PropTypes.string.isRequired,
    }).isRequired,
};

const XlsxIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#45cd77"
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
         className="lucide lucide-file-spreadsheet h-4 w-4 text-success">
        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
        <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
        <path d="M8 13h2"></path>
        <path d="M14 13h2"></path>
        <path d="M8 17h2"></path>
        <path d="M14 17h2"></path>
    </svg>
)

const CsvIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#5c97f7"
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
         className="lucide lucide-file-text h-4 w-4 text-info">
        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
        <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
        <path d="M10 9H8"></path>
        <path d="M16 13H8"></path>
        <path d="M16 17H8"></path>
    </svg>
);

const JsonIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f6ae31"
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
         className="lucide lucide-file-json h-4 w-4 text-warning">
        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
        <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
        <path d="M10 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1"></path>
        <path d="M14 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1"></path>
    </svg>
)

function FileName({feed}) {
    const intl = useIntl();

    function getIconByType(type) {
        switch (type) {
            case 'csv':
                return <CsvIcon />
            case 'json':
                return <JsonIcon />
            default:
                return <XlsxIcon />
        }
    }

    return (
        <div style={{
            display: 'flex',
            gap: '8px'
        }}>
            <div style={{alignSelf: 'center'}}>
                {getIconByType(feed.dataType)}
            </div>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
            }}>
                <div style={{fontSize: '14px', fontWeight: 500}}>
                    {feed.name}
                </div>
                <div style={{fontSize: '12px', textTransform:'uppercase', color: '#6B7280'}}>
                    {feed.dataType} · {intl.formatMessage({id: `feed.transportType.${feed.transportType}`, defaultMessage: feed.transportType})}
                </div>
            </div>
        </div>
    );
}

export default FileName;
